import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import "./styles/Menu.css";
import "./styles/global.css";

import PromiseLoader from "./components/alert/PromiseLoader";
import DataProvider from "./redux/store";

ReactDOM.render(
	<React.StrictMode>
		<DataProvider>
			<App />
			<PromiseLoader />
		</DataProvider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
